import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Youtube = function Youtube(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.036 2.4c.455 0 5.035.017 6.224.343a2.005 2.005 0 011.41 1.41C16 5.354 16 7.806 16 8.002v.04c-.001.282-.02 2.645-.33 3.82a2.005 2.005 0 01-1.41 1.411c-1.177.31-5.673.328-6.208.33h-.104c-.534-.002-5.02-.021-6.208-.343a2.005 2.005 0 01-1.41-1.41C.02 10.686 0 8.312 0 8.029v-.056c.001-.282.02-2.644.33-3.82a2.046 2.046 0 011.41-1.424c1.19-.313 5.768-.328 6.223-.33h.073zm-1.63 3.202V10.4L10.57 8 6.405 5.602z",
    fill: "currentColor"
  }));
};
export default Youtube;